// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"f2753f6e","438":"c0739578","514":"9ff529f0","589":"a13532d1","648":"c7d4dbba"}[chunkId] + ".chunk.js";
};